<template>
  <div class="galleryWrapper">
    <div v-if="maxImage" :style="wrapperStyle">
      <div v-for="(image, index) in maxImage" :key="index" :style="imageStyle" class="galleryWrapper__lists">
        <div class="galleryWrapper__lists__image">
          <i v-if="urlImg && (getFileExtension(urlImg[index]) === 'pdf' || getFileExtension(urlImg[index]) === 'rar' || getFileExtension(urlImg[index]) === 'zip')" class="icon-download download" :style="eyeIconStyle" @click="emitDownload(index)"></i>
          <i v-else-if="isDownload"  class="icon-download download" :style="eyeIconStyle" @click="emitDownload(index)"></i>
          <i v-else class="icon-eye eye" :style="eyeIconStyle" @click="seeDetail(index)"></i>
          <img :src="images[index]" alt="" @click="isDownload ? emitDownload(index) : seeDetail(index)">
          <div class="title">
            <span v-if="title" class="small-font">{{index + 1}}. file{{getNameGql(title[index])}}</span>
            <span v-else class="small-font">{{index + 1}}.{{getName(images[index])}}</span>
          </div>
          <div class="galleryWrapper__lists__image__button" @click="emitDelete(index)">
            <i class="icon-clear"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-else :style="wrapperStyle">
      <div v-for="(image, index) in images" :key="index" :style="imageStyle" class="galleryWrapper__lists">
        <div class="galleryWrapper__lists__image">
          <i v-if="isDownload || (urlImg && (getFileExtension(urlImg[index]) === 'pdf' || getFileExtension(urlImg[index]) === 'rar' || getFileExtension(urlImg[index]) === 'zip'))" 
          class="icon-download download" :style="eyeIconStyle" @click="emitDownload(index)"></i>
          <i v-else-if="isDownload" :style="eyeIconStyle" @click="emitDownload(index)"></i>
          <i v-else class="icon-eye eye" :style="eyeIconStyle" @click="seeDetail(index)"></i>
          <img :src="image" alt="" @click="isDownload ? emitDownload(index) : seeDetail(index)">
          <div class="title">
            <span v-if="title" class="small-font">{{index + 1}}. file{{getNameGql(title[index])}}</span>
            <span v-else class="small-font">{{index + 1}}.{{getName(images[index])}}</span>
          </div>
          <div class="galleryWrapper__lists__image__button" @click="emitDelete(index)">
            <i class="icon-clear"></i>
          </div>  
        </div>
      </div>
    </div>
    <div v-if="isOverlayOpen" class="galleryWrapper__detail">
      <slick v-if="maxImage" ref="slick" :options="slickOptions" class="galleryWrapper__detail__slick">
        <div v-for="(image, index) in maxImage" :key="index" class="galleryWrapper__detail__slick__imageWrapper">
          <img :src="images[index]" alt="">
          <div class="bottom">
            <div class="name">{{getName(images[index])}}</div>
            <button class="btn-regular secondary" @click="emitDownload(index)">Download</button>
          </div>
        </div>
      </slick>
      <slick v-else ref="slick" :options="slickOptions" class="galleryWrapper__detail__slick">
        <div v-for="(image, index) in images" :key="index" class="galleryWrapper__detail__slick__imageWrapper">
          <img :src="image" alt="">
          <div class="bottom">
            <div class="name">{{getName(images[index])}}</div>
            <button class="btn-regular secondary" @click="emitDownload(index)">Download</button>
          </div>
        </div>
      </slick>
      <div class="galleryWrapper__detail__slick__exit" @click="closeOverlay">x</div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  name: 'adx-gallery-slideshow',
  components: {
    'slick': Slick,
  },
  props: {
    images: {
      required: true
    },
    maxImage: {
      required: false,
    },
    isDownload:{
      required: false,
    },
    title:{
      required:false
    },
    urlImg:{
      required: false
    },
    wrapperStyle: {
      required: false,
      type: Object,
      default: () => {
        return {
          "display": "flex",
          "flex-flow": "row",
        }
      },
    },
    imageStyle: {
      required: false,
      type: Object,
      default: () => {
        return {
          "width": "60px",
          "height": "60px",
          "margin-right": "8px",
          "overflow": "hidden",
          "margin-left": "10px"
        }
      },
    },
    eyeIconStyle: {
      required: false,
      type: Object,
      default: () => {
        return {
          "font-size": "24px",
          "margin-top": "20px",
          "margin-left": "20px"
        }
      },
    },
  },
  data() {
    return {
      index: 0,
      isOverlayOpen: false,
      selected: null,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        infinite: false,
        nextArrow: '<button type="button" style="' +
                  'top:32%; width:48px; height:48px; position:absolute; right:-64px;"' +
                  'aria-disabled="false"><i class="icon-chevronright" style="font-size: 32px"></i></button>',
        prevArrow: '<button type="button" style="' +
                  'top:32%; width:48px; height:48px; position:absolute; left:-64px;"' +
                  'aria-disabled="false"><i class="icon-chevronleft" style="font-size: 32px"></i></button>',
      },
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    emitDelete(index) {
      this.$emit('deletedImage', index)
    },
    emitDownload(index){
      this.$emit('downloadedImg', this.images[index], index)
    },
    seeDetail(index) {
      this.slickOptions.initialSlide = index
      this.isOverlayOpen = !this.isOverlayOpen
    },
    closeOverlay() {
      this.isOverlayOpen = !this.isOverlayOpen
    },
    getName(raw) {
      let name = raw.split('/').pop()
      return name
    },
    getNameGql(raw) {
      let name = raw.split('-').pop()
      return name
    },
    getFileExtension(type) {
      let fileExts = type.substring(type.lastIndexOf('.')+1, type.length)
      return fileExts
    },
    deleteImage(index) {
      /* Note:
        Delete method inside preview is different (not emitting event) because the slick needs to be created again (reSlick),
        so the list can be updated when it changed/deleted. The reSlick() still has bug so it used destroy -> create instead.
      */
    //  console.log('delete image')
      this.images.splice(index, 1)
      this.$refs.slick.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
        this.$refs.slick.goTo(index, true)
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>